module.exports = __webpack_public_path__ + "img/info_round_pl.b3446390.svg";